import { ca } from '@cian/analytics';

import { EPageKind } from '../../../types/page';
import { getEventCategoryFromPageKind } from '../../../utils/tracking';

interface IOptions {
  pageKind: EPageKind;
  cardTitle: string;
}

export function trackCardClick({ pageKind, cardTitle }: IOptions) {
  ca('eventSite', {
    category: getEventCategoryFromPageKind(pageKind),
    action: 'property_guides_click',
    label: cardTitle,
  });
}
